// extracted by mini-css-extract-plugin
export default {"airplaneSizingContainer":"Iba-z","narrowOptionButtons":"Jba-z","noOptions":"Kba-z"};